import { ColocaBadge } from "@/shared/components/data-display/ColocaBadge";
import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import { BUCKET_BADGE_VARIANT, STATUS_LABEL_KEYS } from "../constants/paymentsActivity.constants";
import type { ActivityRow } from "../types/paymentsActivity.types";

export interface ActivityStatusPillProps {
  row: Pick<ActivityRow, "bucket" | "isNonTerminal" | "status">;
  className?: string;
}

/**
 * Status badge for a runtime operation: the label is the translated raw status (granular — Rechazado ≠
 * Revertido ≠ Fallido; unknown runtime statuses fall back to the raw enum), the color comes from the display
 * bucket, and the leading dot gets a contained opacity pulse while the operation is still in flight — "live"
 * reads at a glance, no layout shift. The same label map drives the status filter, so filter and badge always
 * agree.
 */
export function ActivityStatusPill({ row, className }: ActivityStatusPillProps) {
  const { t } = useTranslations("paymentsActivity");
  const labelKey = STATUS_LABEL_KEYS[row.status];

  return (
    <ColocaBadge variant={BUCKET_BADGE_VARIANT[row.bucket]} className={className}>
      <span
        aria-hidden="true"
        className={cn(
          "mr-1 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-current",
          row.isNonTerminal && "animate-pulse",
        )}
      />
      {labelKey ? t(labelKey) : row.status}
    </ColocaBadge>
  );
}
